import { useMemo } from "react";

export const useFilteredPlayers = (players, search, sortBy) => {
    return useMemo(() => {
        const lower = search.toLowerCase();
        const filtered = (players || []).filter(player =>
            player.name?.toLowerCase().includes(lower) ||
            player.steam_id?.toLowerCase().includes(lower)
        );

        return [...filtered].sort((a, b) => {
            if (sortBy === "game_times") return b.game_times - a.game_times;
            return String(b[sortBy] || "").localeCompare(String(a[sortBy] || ""));
        });
    }, [players, search, sortBy]);
};
